import App from "../src/features/save/src/components/App";

document.addEventListener("DOMContentLoaded", () => {
  const application = new App();

  application.initialize("saveItemAfterAuthentication");
});
